import { render, staticRenderFns } from "./Tetraproduct.vue?vue&type=template&id=74aac444&scoped=true"
import script from "./Tetraproduct.vue?vue&type=script&lang=js"
export * from "./Tetraproduct.vue?vue&type=script&lang=js"
import style0 from "./Tetraproduct.vue?vue&type=style&index=0&id=74aac444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74aac444",
  null
  
)

export default component.exports